module.exports = __webpack_public_path__ + "img/2_76.8de61c56.png";